/* eslint-disable */
import { FC } from 'react';
import styles from '../../styles/components/controlVariations/ConfirmDownloadModal.module.css';
import QuestionMarkIcon from '../../assets/images/icon/download.png';

interface Props {
	onDelete: () => void;
	onCancel: () => void;
}

const DeleteConfirmContent: FC<Props> = ({ onDelete, onCancel }) => {
	return (
		<div className={styles.modal}>
			<div className={styles.iconWrapper}>
				<img src={QuestionMarkIcon} alt="Delete" />
			</div>

			<h2 className={styles.title}>Delete this assignment submission?</h2>

			<div className={styles.actions}>
				<button className={styles.logoutButton} onClick={onDelete}>
					Delete
				</button>
				<button className={styles.cancelButton} onClick={onCancel}>
					Cancel
				</button>
			</div>
		</div>
	);
};

export default DeleteConfirmContent;
